import React from 'react';
import RecipeTitle from './RecipeFields/RecipeTitle';
import RecipeCategory from './RecipeFields/RecipeCategory';
import Servings from './RecipeFields/Servings';
import CookingTime from './RecipeFields/CookingTime';
import IngredientList from './RecipeFields/IngredientList';
import Instructions from './RecipeFields/Instructions';
import SpecialNotes from './RecipeFields/SpecialNotes';
import Signature from './RecipeFields/Signature';

export default function RecipePreviewCard({
  title = 'Untitled',
  category = '—',
  servings = '—',
  cookingTime = '—',
  ingredients = [],
  instructions = [],
  notes = '',
  backgroundImage = '',
  authorName = '',
  forceExactSize = false,

}) {

    // 🔍 Add this log here
  // console.log("👀 Preview Props", {
  //   title,
  //   category,
  //   servings,
  //   cookingTime,
  //   backgroundImage,
  //   ingredients,
  //   instructions,
  //   notes,
  //   authorName
  // });
  const resolvedBackgroundURL = backgroundImage
    ? `${process.env.REACT_APP_API_BASE_URL}/${backgroundImage.replace(/^\/+/, '')}`
    : '';

  return (
    <div className={forceExactSize ? "w-[600px] h-[900px]" : "flex justify-center items-center px-2 py-4 w-full"}>
      {/* ✅ Preload background image to fix blank html2canvas output */}
      {resolvedBackgroundURL && (
        <img
          src={resolvedBackgroundURL}
          alt="Preload Background"
          style={{ display: 'none' }}
          onLoad={() => console.log("✅ Background image loaded")}
        />
      )}
      <div className={forceExactSize ? "w-[600px] h-[900px] relative" : "w-full max-w-[600px] aspect-[2/3] relative"}>
        <div
            className="
              absolute top-0 left-0 w-full h-full
              p-[10.7%_6.1%_10%_6.1%]
              grid grid-rows-[10%_8%_76%_6%] grid-cols-1 gap-[0.5%]
              rounded-[15px] font-serif
              bg-cover bg-center overflow-hidden
            "
          style={{
            backgroundImage: resolvedBackgroundURL ? `url(${resolvedBackgroundURL})` : 'none',
            backgroundColor: resolvedBackgroundURL ? 'transparent' : '#fefefe',
          }}
        >
          {/* 🟦 Title */}
          <div className="row-start-1 h-full w-full px-[3%] py-[2%] flex items-center justify-center frosted-title">
            <div className="w-full h-full">
              <RecipeTitle title={title} readOnly />
            </div>
          </div>

          {/* 🟩 Details */}
          <div className="row-start-2 h-full w-full flex justify-between items-center px-[4%] py-[2%] gap-[2%] text-[0.9em] md:text-[1em] frosted-details">
            <div className="w-1/3 h-full text-center flex flex-col justify-center">
              <RecipeCategory category={category} readOnly />
            </div>
            <div className="w-1/3 h-full text-center flex flex-col justify-center">
              <Servings servings={servings} readOnly />
            </div>
            <div className="w-1/3 h-full text-center flex flex-col justify-center">
              <CookingTime cookingTime={cookingTime} readOnly />
            </div>
          </div>

          {/* 🟪 Ingredients + Instructions */}
          <div className="row-start-3 grid grid-cols-[39%_59%] gap-[2%] h-full">
            {/* Left Column */}
            <div className="grid grid-rows-[80%_19.01%] gap-[1%] ml-[1%] h-full w-full">
              {/* 🍴 Ingredients Section */}
                <div className="h-full w-full frosted-block p-2 overflow-hidden">
                <IngredientList ingredients={ingredients} readOnly />
              </div>
              {/* 📝 Special Notes Section */}
              <div className="h-full w-full frosted-block p-2 overflow-hidden">
                <SpecialNotes notes={notes} readOnly />
              </div>
            </div>

            {/* Right Column */}
            <div className="frosted-block mr-[2%] h-full w-full p-[2%]">
              <Instructions instructions={instructions} readOnly />
            </div>
          </div>

          {/* 🟣 Footer: Signature */}
          <div className="row-start-4 flex justify-center items-center px-[2%] pb-[1%] h-full frosted-footer">
            <Signature defaultName={authorName} readOnly />
          </div>
        </div>
      </div>
    </div>
  );
}